import React, { Component } from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import constant from 'lodash/constant';

export default class LoadingEnginesList extends Component {
  render(){
    let { number } = this.props;
    let list = times(number, constant(null));
    return (
      <ol className="engines-list loading">
        { list.map((item, index) => {
          return (
            <li key={index}>
              <div className="inner">
                <div className="image-container">
                  <div className="dummy"></div>
                  <div className="image">
                    <div className="preloader"></div>
                  </div>
                </div>
              </div>
            </li>
          );}
        )}
      </ol>
    );
  }
}

LoadingEnginesList.propTypes = {
  number: PropTypes.number,
};
